import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteJobTitleModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobTitleModal" */
      './DeleteJobTitleModal'
    ),
  loading: LoadingModal,
});
